import * as PropTypes from 'prop-types'

const ExecutionShape = PropTypes.shape({

})

export { ExecutionShape }
